<template>
  <div class="opea-items" v-if="isShowStreamLine">
    <div class="items-box" :class="{ wap: device == 'wap' }">
      <div
        class="quality-menu"
        :class="{ show: isShowStreamLineBox }"
        @click="stopPropagation($event)"
      >
        <ul class="quality-line">
          <li
            v-for="(line, i) in lineList"
            :key="i"
            @click="changeLine(line)"
            :class="{ active: line == defaultStream.path_name }"
          >
            {{ line }}
          </li>
        </ul>
        <ul class="quality-stream">
          <li
            v-for="(s, j) in streamList"
            :key="j"
            @click="changeStream(s)"
            :class="{ active: s == defaultStream.label }"
          >
            {{ s | bitrateForm }}
          </li>
        </ul>
      </div>
    </div>
    <span
      class="icon icontemp qingxidu"
      :class="{ wap: device == 'wap' }"
      @click="changeQuality($event)"
    ></span>
    <span
      class="opea-text"
      v-if="device != 'wap'"
      @click="changeQuality($event)"
      >清晰度</span
    >
  </div>
</template>

<script>
import { $subscriber } from "fire-wind-water";
import $ from "jquery";

export default {
  name: "Line",
  props: {
    device: String
  },
  data() {
    return {
      isShowStreamLine: false,
      streamList: [], //码流
      lineList: [], //线路
      isShowStreamLineBox: false,
      defaultStream: {}
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      $subscriber.subscribe("onVideoStatus", data => {
        // this.isShowStreamLine = window.Mudu.Room.HasMultiStreamLine();
        if (this.isShowStreamLine) {
          let list = window.Mudu.Room.GetPlayAddrList();
          let stream = [];
          let line = [];
          for (let i of list[0].sources) {
            if (i) {
              stream.push(i.label);
              line.push(i.path_name);
              if (i.defaultPlay) {
                this.defaultStream = i;
              }
            }
          }
          this.streamList = [...new Set(stream)];
          this.lineList = [...new Set(line)];
          setTimeout(() => {
            $(document).click(() => {
              this.isShowStreamLineBox = false;
            });
            $(".mudu-video-wrap").click(() => {
              this.isShowStreamLineBox = false;
            });
          }, 0);
        }
      });
    },
    changeQuality(event) {
      event.stopPropagation();
      this.isShowStreamLineBox = !this.isShowStreamLineBox;
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    changeLine(line) {
      this.searchLine(line, this.defaultStream.label);
    },
    changeStream(s) {
      this.searchLine(this.defaultStream.path, s);
    },
    searchLine(line, stream) {
      let list = window.Mudu.Room.GetPlayAddrList();
      for (let i of list[0].sources) {
        if (i) {
          if (i.label == stream && i.path == line) {
            this.defaultStream = i;
            $subscriber.emit("change-line-stream", i);
          }
        }
      }
    }
  },
  filters: {
    bitrateForm: function(value) {
      if (!value) return "";
      var returnValue = "";
      switch (value) {
        case "origin":
          returnValue = "原画";
          break;
        case "fhd":
          returnValue = "超清 \u00a0\u00a0 1080P";
          break;
        case "hd":
          returnValue = "高清 \u00a0\u00a0 720P";
          break;
        case "sd":
          returnValue = "标清 \u00a0\u00a0  480P";
          break;
      }
      return returnValue;
    }
  }
};
</script>

<style scoped></style>
